// extracted by mini-css-extract-plugin
module.exports = {"viewer":"MarkdownViewer-module_viewer_2BmRI","preview":"MarkdownViewer-module_preview_1Hs78"};